import { render, staticRenderFns } from "./modelEight.vue?vue&type=template&id=2db4ff38&scoped=true&"
import script from "./modelEight.vue?vue&type=script&lang=js&"
export * from "./modelEight.vue?vue&type=script&lang=js&"
import style0 from "./modelEight.vue?vue&type=style&index=0&id=2db4ff38&lang=scss&scoped=true&"
import style1 from "./modelEight.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4ff38",
  null
  
)

export default component.exports